export enum Locale {
    en_US = "en-US",
    he_IL = "he-IL",
}